export default ({ store }) => {
  const watchers = {
    'store/CHANGE_SHIPPING_COUNTRY' (payload) {
      store.dispatch('session/UPDATE', { country_ship: payload })
    },
    'store/SET_EMAIL' (payload) {
      store.dispatch('session/UPDATE', { email: payload })
    }
  }

  store.subscribe((mutation, state) => {
    if (mutation.type in watchers) watchers[mutation.type](mutation.payload)
  })
}